import './behaviors/smooth-scrolling';
import './behaviors/splash';
import './behaviors/waypoints';
import './behaviors/scroll-after-submit';
